export const footer: any = {};

footer.setNoPrimaryFooter = (state) => {
	state.primaryFooter.classList.add("hideFooter");
};

footer.hide = (state) => {
	state.primaryFooter.classList.add("hideSection");
};

export default footer;
